module.exports = __webpack_public_path__ + "static/media/24-c-piano.2a71db19.svg";